export const theme = {
    colors: {
        backgroundColor: "#d3d8de",
        headerBg: "#d3d8de",
        footerBg: 'white'
    }
}